import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Skeleton loading state for trip cards on the Dashboard
 */
const TripCardSkeleton = () => (
  <Card className="overflow-hidden">
    <CardHeader className="pb-2">
      <div className="flex justify-between items-start">
        <div className="space-y-2 flex-1">
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
        <Skeleton className="h-6 w-20 rounded-full" />
      </div>
    </CardHeader>
    <CardContent>
      <div className="space-y-3">
        {/* Progress bar skeleton */}
        <Skeleton className="h-2 w-full rounded-full" />
        
        {/* Stats row */}
        <div className="flex justify-between items-center">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-16" />
        </div>
        
        {/* Travelers skeleton */}
        <div className="flex gap-1 mt-2">
          <Skeleton className="h-8 w-8 rounded-full" />
          <Skeleton className="h-8 w-8 rounded-full" />
          <Skeleton className="h-8 w-8 rounded-full" />
        </div>
      </div>
    </CardContent>
  </Card>
);

/**
 * Multiple skeleton cards for loading state
 */
const TripCardSkeletonList = ({ count = 3 }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    {Array.from({ length: count }).map((_, i) => (
      <TripCardSkeleton key={i} />
    ))}
  </div>
);

export { TripCardSkeleton, TripCardSkeletonList };
export default TripCardSkeleton;
